import React from 'react';
import { Input ,Form} from 'antd';
import PropTypes from 'prop-types';

const ReusableInput = ({
  value,
  onChange,
  placeholder,
  label,
  type,
  size,
  prefix,
  suffix,
  capsOn =false,
  ...rest
}) => {
  return (
    <div className='reusable-input'>
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        size={size}
        prefix={prefix}
        suffix={suffix}
        {...rest}
        onInput={capsOn ? e => e.target.value = e.target.value.toUpperCase() : null}
      />
    </div>
  );
};

ReusableInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  prefix: PropTypes.element,
  suffix: PropTypes.element,
};

ReusableInput.defaultProps = {
  label: '',
  value: '',
  onChange: () => {},
  placeholder: '',
  type: 'text',
  size: 'middle',
  prefix: null,
  suffix: null,
};

export default ReusableInput;
